import request from "../utils/request";

// pkgInfo/queryListWithoutNoPay
export function queryListWithoutNoPay(data) {
  return request({
    url: '/pkgInfo/queryListWithoutNoPay',
    method: 'post',
    data: data
  })
}

export function printPkgWayBillV2(data) {
  return request({
    url: '/express/printPkgWayBill/V2',
    method: 'post',
    data: data
  })
}

// express/cancelExpressPkg
export function cancelExpressPkg(data) {
  return request({
    url: '/express/cancelExpressPkg',
    method: 'post',
    data: data
  })
}

// excel/exportExcelUrl
export function exportExcelUrl(data) {
  return request({
    url: '/excel/exportExcelUrl',
    method: 'post',
    data: data
  })
}
